// src/components/store/sections/testimonials/TestimonialV104CardsliderTealLagoon.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV104CardsliderTealLagoon(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={104}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
